var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main" }, [
    _c(
      "div",
      { staticClass: "Switch_roles", attrs: { id: "roleChooseWindow" } },
      [
        _c("img", {
          staticClass: "close b-close",
          attrs: { src: require("../assets/image/close.png"), alt: "" },
        }),
        _c("p", { staticClass: "lost" }, [
          _vm._v(_vm._s(_vm.$t("switch_character_text"))),
        ]),
        _c("div", { staticClass: "Server" }, [
          _c("i", { staticClass: "fa fa-list-ul color" }),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.serverCode,
                  expression: "serverCode",
                },
              ],
              staticClass: "select_back",
              on: {
                change: [
                  function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.serverCode = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  function ($event) {
                    return _vm.loadRoleList()
                  },
                ],
              },
            },
            _vm._l(_vm.serverList, function (server) {
              return _c("option", { domProps: { value: server.serverCode } }, [
                _vm._v(_vm._s(server.serverName)),
              ])
            }),
            0
          ),
        ]),
        _c("div", { staticClass: "Server_role" }, [
          _c("i", { staticClass: "fa fa-user color" }),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.roleId,
                  expression: "roleId",
                },
              ],
              staticClass: "select_back",
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.roleId = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            _vm._l(_vm.roleList, function (role) {
              return _c("option", { domProps: { value: role.roleId } }, [
                _vm._v(_vm._s(role.roleName)),
              ])
            }),
            0
          ),
        ]),
        _c(
          "button",
          {
            staticClass: "Switch_confirmation bg_color",
            on: {
              click: function ($event) {
                return _vm.chooseRoleInfo()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("confirm_text")))]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }